import { Heart, Home, Stethoscope, Wheat } from 'lucide-react'
import DonateButton from '../components/DonateButton'
import PageHero from '../components/PageHero'
import Reveal from '../components/Reveal'
import ZeffyDonationPanel from '../components/ZeffyDonationPanel'

const tiers = [
  { amount: '$25', title: 'Feed Support', text: 'Helps provide hay, grain, or nutritional support.' },
  { amount: '$50', title: 'Care Essentials', text: 'Supports routine medical needs, supplies, and medications.' },
  { amount: '$100', title: 'A Month of Support', text: 'Contributes to food, shelter, hoof care, and daily upkeep.' },
  { amount: '$350', title: 'A Larger Care Need', text: 'Helps with a farrier visit, repair, treatment, or special care.' },
  { amount: '$500', title: 'Healing in Action', text: 'Makes a meaningful contribution toward rehabilitation and long-term care.' },
  { amount: 'Any', title: 'Custom Gift', text: 'Every amount helps the sanctuary keep showing up for the herd.' },
]

export default function DonatePage() {
  return (
    <>
      <PageHero eyebrow="Support the sanctuary" title="Every gift becomes practical care for a rescued horse." image="/images/horse-portrait-1.webp">
        <p>Your support helps turn uncertainty into steady meals, clean shelter, medical attention, and a future protected by compassion.</p>
      </PageHero>

      <section className="section section--cream">
        <div className="container donation-intro">
          <Reveal className="content-block">
            <span className="eyebrow">Why your support matters</span>
            <h2>The peaceful field is only possible because someone paid for the work behind it.</h2>
            <p className="lead">
              A sanctuary runs on real resources: hay deliveries, veterinary appointments, medication, farrier care, bedding, repairs, equipment, and the people who show up every day.
            </p>
            <DonateButton href="#donation-form" className="button button--gold button--large" label="Go to donation form" />
            <p className="microcopy">Donations are completed securely through the sanctuary’s official Zeffy form below.</p>
          </Reveal>
          <Reveal className="care-grid" delay={100}>
            {[
              { icon: Home, label: 'Shelter' },
              { icon: Stethoscope, label: 'Medical' },
              { icon: Heart, label: 'Healing Care' },
              { icon: Wheat, label: 'Feed' },
            ].map((item) => (
              <div key={item.label}><item.icon /><span>{item.label}</span></div>
            ))}
          </Reveal>
        </div>
      </section>

      <section className="section">
        <div className="container">
          <Reveal className="section-heading section-heading--center">
            <span className="eyebrow">Suggested giving levels</span>
            <h2>Choose the level that fits your heart and budget.</h2>
          </Reveal>
          <div className="tier-grid">
            {tiers.map((tier, index) => (
              <Reveal className="tier-card" key={`${tier.amount}-${tier.title}`} delay={(index % 3) * 80}>
                <span className="tier-card__amount">{tier.amount}</span>
                <h3>{tier.title}</h3>
                <p>{tier.text}</p>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <section className="section section--cream donation-form-section" id="donation-form" aria-labelledby="donation-heading" tabIndex={-1}>
        <div className="container">
          <Reveal className="section-heading section-heading--center">
            <span className="eyebrow">Secure giving</span>
            <h2 id="donation-heading">Donation</h2>
            <p>Help us continue giving rescued horses the care, comfort, and safety they deserve.</p>
          </Reveal>
          <ZeffyDonationPanel />
        </div>
      </section>

      <section className="section section--green">
        <div className="container quote-panel">
          <Reveal>
            <span className="eyebrow eyebrow--light">Every contribution counts</span>
            <blockquote>“Your gift does not simply fund a place. It protects a life, preserves a promise, and makes another day of comfort possible.”</blockquote>
          </Reveal>
        </div>
      </section>
    </>
  )
}
